import React from 'react';
import { Navigate } from 'react-router-dom';
// MUDANÇA 1: Importar AuthState junto com o hook
import { useAuthStore, AuthState } from '../stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  // MUDANÇA 2: Especificar o tipo do parâmetro 'state'
  const isAuthenticated = useAuthStore((state: AuthState) => state.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;